"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alignments = void 0;
var Alignments;
exports.Alignments = Alignments;

(function (Alignments) {
  Alignments["CENTER"] = "center";
  Alignments["LEFT"] = "left";
  Alignments["RIGHT"] = "right";
})(Alignments || (exports.Alignments = Alignments = {}));